import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Experience } from '../../interfaces/ExperienceProduct';

export interface Products {
  searchRows: Experience[];
  }

const initialState: Products = {
  searchRows: [],
};

export interface InputQuantity {
  id: number;
  quantity: number;
};

export const experienceSlice = createSlice({
  name: 'experience',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Experience[]>) => {
        state.searchRows = action.payload;
    },
  }
})

export const { set } = experienceSlice.actions;
export default experienceSlice.reducer;
